
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".faq-question").forEach(button => {
        button.addEventListener("click", () => {
            const answer = button.nextElementSibling;
            if (answer) {
                answer.classList.toggle("show");
            }
        });
    });
});
